module.exports = __webpack_public_path__ + "static/img/发网.791c1652.png";